
const OperationContentType = Symbol();

export class OperationContent {
    [OperationContentType]: any;
    readonly value: string;

    private constructor(operationContent: string) {
        this.value = operationContent;
    }

    static fromString(operationContent: string): OperationContent {
        return new OperationContent(operationContent);
    }
}
